var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"position-relative"},[_c('img',{staticClass:"card-img-top",attrs:{"src":_vm.simulator.icon_image}}),_c('div',{staticClass:"card-body"},[_c('h4',[_vm._v(_vm._s(_vm.simulator.name))]),_vm._v(" "+_vm._s(_vm.simulator.subtitle)+" ")])]),_c('div',{staticClass:"card-footer"},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":{
        name: 'tools',
        params: { slug: 'simulators', subslug: _vm.simulator.slug }
      }}},[_vm._v(" Realizar simulado ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }